const ExperienceData = [
  {
    id: 1,
    jobtitle: "Head of Department",
    companyname: "Social Boost",
    worktype: "Full-time",
    duration: "Jan 2021 - Oct 2021",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Guided a team of 70 Instagram growth specialists and over 5 team leaders.`,
      `Revised company marketing practices, switched strategies at least once a month, and applied updates to training programs.`,
      `Developed new growth strategies to improve results for over 6 thousand customers and arranged weekly meetings with the company Directors.`,
      `In 10 months improved retention rate by almost 15%.`,
      `Resolved all client complaints by collaborating with over 3 other departments such as sales, customer support, and the onboarding team.`,
      `Individual performance review and weekly meetings with the team.`,
    ],
  },
  {
    id: 2,
    jobtitle: "Team Lead",
    companyname: "Social Boost",
    worktype: "Full-time",
    duration: "Sep 2020 - Jan 2021",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Mentored a team of 3-4 Instagram growth specialists and encouraged the highest levels of quality performance.`,
      `Collaborated with the customer support team to ensure we deliver the best result to all 200+ customers.`,
      `Weekly performance report to management.`,
      `Supported the improvement of over 4 social media growth strategies.`,
    ],
  },
  {
    id: 3,
    jobtitle: "Instagram Growth Specialist",
    companyname: "Social Boost",
    worktype: "Full-time",
    duration: "Jul 2020 - Sep 2020",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Hand-growing Instagram accounts manually via the Instagram app.`,
      `Interacting with people to generate highly engaged niche audiences.`,
      `Researching targets to ensure the highest quality Instagram growth is achieved.`,
      `Using organic Instagram growth techniques`,
      `Doing hashtag and competitor account research`,
      `Heling with audience and engagement building`,
    ],
  },
  {
    id: 4,
    jobtitle: "Sales Specialist",
    companyname: "Be-Canadian Immigration Agency",
    worktype: "Full-time",
    duration: "Jul 2019 - Feb 2020",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Reaching out to customers interested in immigration to Canada via phone calls (warm calls).`,
      `Offering services using solid arguments and providing information on how immigration works.`,
      `Maintaining positive business/customer relationships.`,
      `Achieving monthly sales targets. `,
      `Providing management with reports of daily activity using the CRM system. `,
      `Writing custom e-mails to customers. `,
      `Using follow-up/callback strategies. `,
      `I also helped with hiring new people and providing them with training`,
    ],
  },
  {
    id: 5,
    jobtitle: "Chief Executive Officer",
    companyname: "Catrisa Lingerie",
    worktype: "Self-employed",
    duration: "2019 - 2020",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Online lingerie store start-up catrisa.ge. I was managing all the aspects of the company on my own. Sales were done online/locally only. My first business failed and the biggest reason was Covid-19 as I was unable to fulfill the orders and refill the stock. Received a lot of experience in how retail business works and improved my skills with customer support, web development, local SEO as well as content and social media management.`,
    ],
  },
  {
    id: 6,
    jobtitle: "Promotion Agent",
    companyname: "Nightclubs / Bars and Restaurant",
    worktype: "Freelance",
    duration: "2017 - 2019",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Approaching potential customers, giving presentations, distributing fliers, and promoting the services/idea to join specific bars/clubs.`,
      `I mostly worked with foreign customers in English, Russian, and sometimes German.`,
    ],
  },
  {
    id: 7,
    jobtitle: "Sales Specialist",
    companyname: "Next Brand",
    worktype: "Full-time",
    duration: "Jul 2015 - Jul 2017",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Reaching out to existing/potential customers via phone calls including cold and warm calls.`,
      `Promoting/selling services using solid arguments.`,
      `Maintaining positive business/customer relationships.`,
      `Achieving monthly sales targets. `,
      `Providing management with reports of daily activity using the CRM system. `,
      `Writing custom e-mails to customers. `,
      `Using follow-up/callback strategies. `,
    ],
  },
  {
    id: 8,
    jobtitle: "Child Care Specialist",
    companyname: "Au Pair",
    worktype: "Full-time",
    duration: "Jul 2014 - Jul 2015",
    location: "Breisach am Rhein, Baden-Württemberg, Germany",
    responsibility: [
      `Taking host child to kindergarten. `,
      `Playing, reading, or walking outside with the host child. `,
      `Cooking food and cleaning the room for the host child, including minor household duties.`,
    ],
  },
  {
    id: 9,
    jobtitle: "Waitress",
    companyname: "Club IVERIA",
    worktype: "Full-time",
    duration: "Jul 2012 - Jul 2014",
    location: "Tbilisi, Georgia",
    responsibility: [
      `Providing customer service. `,
      `Greeting customers and taking food/drink orders. `,
      `Making suggestions based on their preference.`,
      `Keeping ashtrays clean and tables tidy. `,
      `Cooperating between customers and the serving staff. `,
    ],
  },
];

const EducationData = [
  {
    name: "Matriculation",
    status: "In computer science from Millenium's education system",
    year: "2018",
  },
  {
    name: "Intermediate",
    status: "In computer science from Sir syed govt. girls college",
    year: "2020",
  },
  {
    name: "Diploma",
    status: "In graphic designing from Arena multimedia",
    year: "continue",
  },
];

const CertificationData = [
  {
    name: "Front-End Engineer Career Path",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/5f85dd867b67b60014ac9ea3",
  },
  {
    name: "Learn React",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/af00e5032d0a68cc84879983f5d8333b",
  },
  {
    name: "Learn Intermediate JavaScript",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/512386fdc7f6c934f98b01e6afa8285a",
  },
  {
    name: "Learn Intermediate CSS",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/b3dec49423da50603c25618aee635027",
  },
  {
    name: "Create a Professional Website with Velo by Wix Course",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/9605a581bda107153c433f7889dbc268",
  },
  {
    name: "Code Foundations",
    source: "Codecademy",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/5b55e668646caa552f8e4d1d",
  },
  {
    name: "Jira Fundamentals Badge",
    source: "Atlassian",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://university.atlassian.com/student/award/MXrALckUagVqUKYJqdvioenM",
  },
  {
    name: "Trello Fundamentals Badge",
    source: "Atlassian",
    date: "Issued Aug 2022 · No Expiration Date",
    creditUrl:
      "https://university.atlassian.com/student/award/Xz2rCXRVypxn91pD5PsbYrby",
  },
  {
    name: "EF SET English Certificate 73/100 C2 Proficient",
    source: "EF Standard English Test (EF SET)",
    date: "Issued Jul 2022 · No Expiration Date",
    creditUrl: "https://www.efset.org/cert/7dr3HT",
  },
  {
    name: "JavaScript Algorithms and Data Structures",
    source: "freeCodeCamp",
    date: "Issued Jul 2022 · No Expiration Date",
    creditUrl:
      "https://freecodecamp.org/certification/catherineisonline/javascript-algorithms-and-data-structures",
  },
  {
    name: "The Complete JavaScript Course 2022: From Zero to Expert by Jonas Schmedtmann",
    source: "Udemy",
    date: "Issued Jul 2022 · No Expiration Date",
    creditUrl:
      "https://www.udemy.com/certificate/UC-0ce60e41-2077-40bc-8385-b15db83540e5/",
  },
  {
    name: "React + Redux",
    source: "Sololearn",
    date: "Issued Dec 2021 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1097-19028975/pdf",
  },
  {
    name: "Responsive Web Design",
    source: "Sololearn",
    date: "Issued Dec 2021 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1162-19028975/pdf",
  },
  {
    name: "The Web Developer Bootcamp",
    source: "Udemy",
    date: "Issued Dec 2021 · No Expiration Date",
    creditUrl:
      "https://www.udemy.com/certificate/UC-89fa3340-29cd-4ca5-ab45-18efdde98029/",
  },
  {
    name: "Intro to HTML and CSS",
    source: "Lambda School",
    date: "Issued Nov 2021 · No Expiration Date",
    creditUrl: "https://mycourse.app/JN71ZydHJctFJzx37",
  },
  {
    name: "Building Interactive JavaScript Websites Course",
    source: "Codecademy",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/36ae898a1d1c8524815305b2d1d2ebab",
  },
  {
    name: "Learn Bootstrap Course",
    source: "Codecademy",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/0595479d03627a8cb816b069000e4d06",
  },
  {
    name: "Learn Git Course",
    source: "Codecademy",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/a8ab218d5950c29861635cc0bf12fd13",
  },
  {
    name: "Learn JavaScript Course",
    source: "Codecademy",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/705dcb15de0da4dd9d9fc4f3274b430e",
  },
  {
    name: "Learn the Command Line Course",
    source: "Codecademy",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/c87ba0541f8be78bc2f4ba1128233f6f",
  },
  {
    name: "Responsive Web Design",
    source: "freeCodeCamp",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.freecodecamp.org/certification/catherineisonline/responsive-web-design",
  },
  {
    name: "Web Development Career Path",
    source: "freeCodeCamp",
    date: "Issued Sep 2021 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/5b32457b646caa5007c30975",
  },
  {
    name: "SQL course",
    source: "Sololearn",
    date: "Issued Oct 2020 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1060-19028975/pdf/",
  },
  {
    name: "CSS Fundamentals course",
    source: "Sololearn",
    date: "Issued Sep 2020 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1023-19028975/pdf/",
  },
  {
    name: "JavaScript course",
    source: "Sololearn",
    date: "Issued Sep 2020 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1024-19028975/pdf/",
  },
  {
    name: "jQuery course",
    source: "Sololearn",
    date: "Issued Sep 2020 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1082-19028975/pdf/",
  },
  {
    name: "HTML course",
    source: "Sololearn",
    date: "Issued Jul 2020 · No Expiration Date",
    creditUrl: "https://www.sololearn.com/Certificate/1014-19028975/pdf/",
  },
  {
    name: "Build a Website with HTML, CSS, and Github Pages",
    source: "Codecademy",
    date: "Issued Jun 2020 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/5cadfefe5f1de806e9704577",
  },
  {
    name: "Learn CSS",
    source: "Codecademy",
    date: "Issued May 2020 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/9a5bb1fc45b4281af1fffec93b0aaf05",
  },
  {
    name: "Learn HTML",
    source: "Codecademy",
    date: "Issued Mar 2020 · No Expiration Date",
    creditUrl:
      "https://www.codecademy.com/profiles/catherineisonline/certificates/9eb0741e5ebef1f9f58a53bfac67d3a7",
  },
];

export { ExperienceData, EducationData, CertificationData };
